<template>
  <div>
    <div v-if="ui.cargando" class="text-center py-10">
      <div class="spinner spinner-primary"></div>
    </div>

    <template v-else-if="cabecera.mesaVotacionId">
      <div class="pb-20">
     
        <div class="card card-custom mb-5">
          <div class="card-body py-4">
            <div class="d-flex justify-content-between align-items-start flex-wrap">
              <div class="flex-grow-1 min-w-0 pr-3">

                <h3 class="font-weight-bold mb-0"> FICHA DE OBSERVACIÓN ELECTORAL INTEGRAL <span
                  class="label label-inline label-lg label-light-primary font-weight-bold" style="position: relative; top: -3px;">LIMA METROPOLITANA</span></h3>

                <h5 class="mb-0">{{ cabecera.nombre }}</h5>
                <h5 class="mb-0">
                  <small>{{ cabecera.direccion }}</small>
                </h5>
                <h5 class="mb-0">
                  <small class="text-muted">{{ cabecera.regionNombre }} / {{ cabecera.subRegionNombre }}</small>
                </h5>
              </div>
              <div class="text-right flex-shrink-0" v-if="false">>
                <span class="label label-lg label-inline"
                  :class="cabecera.porcentajeAvanceFicha >= 100 ? 'label-light-success' : 'label-light-warning'">
                  Ficha {{ cabecera.porcentajeAvanceFicha }}%
                </span>
                <span class="label label-lg label-inline label-light-info font-weight-bold mr-2 mb-1">
                  Mesa N° {{ cabecera.numeroMesa }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="mb-5">
            <div class="d-flex justify-content-center align-items-start flex-wrap">
                <span class=" card card-custom py-3 px-4 text-white bg-primary font-weight-bold mb-0 h4">  Mesa N° {{ cabecera.numeroMesa }}</span>
            </div>
        </div>

      <ficha-turno-1 :local-votacion-mesa-proceso-electoral-id="cabecera.localVotacionMesaProcesoElectoralId"
                     :mesa-votacion-id="cabecera.mesaVotacionId"
                     :proceso-electoral-id="cabecera.procesoElectoralId"
                     :cabecera="cabecera"
                     :organizaciones="organizaciones"
                     :expandir-contenido.sync="expandirTurno1"
                     @cargado="turno1Cargado = true"
                     @guardado="refrescarAvance" @finalizado="refrescarAvance" />

      <ficha-turno-2 v-if="turno1Cargado"
                     :local-votacion-mesa-proceso-electoral-id="cabecera.localVotacionMesaProcesoElectoralId"
                     :mesa-votacion-id="cabecera.mesaVotacionId"
                     :proceso-electoral-id="cabecera.procesoElectoralId"
                     :cabecera="cabecera"
                     :organizaciones="organizaciones"
                     :expandir-contenido.sync="expandirTurno2"
                     @guardado="refrescarAvance" @finalizado="refrescarAvance" />

      <fab-registro-incidencia
        :local-votacion-mesa-proceso-electoral-id="cabecera.localVotacionMesaProcesoElectoralId"
        :mesa-votacion-id="cabecera.mesaVotacionId"
        :proceso-electoral-id="cabecera.procesoElectoralId"
        :turno="turnoFabDefault" />
      </div>
    </template>

    <div v-else class="alert alert-custom alert-light-danger">
      <div class="alert-text">No se pudo cargar la ficha de esta mesa.</div>
    </div>
  </div>
</template>

<script>
/**
 * Contenedor de la ficha 2026-ERM-LIMA (turnos 1 y 2).
 * Provincia es otra vista / otro FichaTipo.
 */
import FichaTurno1 from "@/components/sheet/2026-ERM/lima/ficha-turno-1";
import FichaTurno2 from "@/components/sheet/2026-ERM/lima/ficha-turno-2";
import FabRegistroIncidencia from "@/components/sheet/2026-ERM/FabRegistroIncidencia";

export default {
  name: "EditFicha2026ErmLima",
  components: { FichaTurno1, FichaTurno2, FabRegistroIncidencia },
  props: {
    esVersionApp: { type: Boolean, default: false },
  },
  data() {
    return {
      ui: { cargando: true },
      cabecera: {},
      organizaciones: [],
      expandirTurno1: true,
      expandirTurno2: false,
      turno1Cargado: false,
    };
  },
  computed: {
    turnoFabDefault() {
      if (this.expandirTurno2 && !this.expandirTurno1) return 2;
      if (this.expandirTurno1 && !this.expandirTurno2) return 1;
      const ruta = Number(this.$route.params.turno || 0);
      return ruta === 2 ? 2 : 1;
    },
  },
  mounted() {
    const turno = Number(this.$route.params.turno || 1);
    this.expandirTurno1 = turno !== 2;
    this.expandirTurno2 = turno === 2;
    this.cargar();
  },
  methods: {
    cargar() {
      const p = this.$route.params;
      this.$http
        .post(this.apiRoute("Sheet", "GetFichaLocalVotacionMesa"), {
          localVotacionId: Number(p.localVotacionId || 0),
          mesaVotacionId: Number(p.mesaVotacionId),
          procesoElectoralId: Number(p.procesoElectoralId),
          turno: p.turno ? Number(p.turno) : null,
          fichaTipoCodigo: "ERM_LIMA_2026",
        })
        .then(function (response) {
          if (this.procesarRespuestaErrorDefecto(response)) {
            this.ui.cargando = false;
            return;
          }
          this.cabecera = response.body.data || {};
          this.ui.cargando = false;
          if (this.cabecera.localVotacionId) this.cargarOrganizaciones();
        }, function (error) {
          this.ui.cargando = false;
          this.mostrarMensajeExcepcionVueResource(error);
        });
    },
    cargarOrganizaciones() {
      this.$http
        .get(this.apiRoute("Parameter", "ListParametrosPoliticos"), {
          params: { Id: this.cabecera.localVotacionId },
        })
        .then(function (response) {
          if (this.procesarRespuestaErrorDefecto(response)) return;
          this.organizaciones = response.body.data || [];
        }, this.mostrarMensajeExcepcionVueResource);
    },
    refrescarAvance(datos) {
      if (!datos) return;
      this.$set(this.cabecera, "porcentajeAvanceFicha", datos.porcentajeAvanceFicha);
      this.$set(this.cabecera, "porcentajeAvanceTurno1", datos.porcentajeAvanceTurno1);
      this.$set(this.cabecera, "porcentajeAvanceTurno2", datos.porcentajeAvanceTurno2);
      if (datos.localVotacionMesaProcesoElectoralId) {
        this.$set(this.cabecera, "localVotacionMesaProcesoElectoralId", datos.localVotacionMesaProcesoElectoralId);
      }
    },
  },
};
</script>
